import { _t } from "@bark/bark-core";

export const CloseBarkConfirmModal = () => {
    const { Handlebars } = window;

    const modalTemplate = Handlebars.compile(document.getElementById('close-bark-confirm-modal-template').innerHTML);
    const cardTemplate = Handlebars.compile(document.getElementById('close-bark-confirm-card-template').innerHTML);

    const titleMap = {
        review  : _t("buyer_project_close-project:rating.review-confirmation"),
        default : _t("buyer_project_close-project:close-confirmation")
    };

    const config = {
        maxBarks : 6,
        minBarks : 4
    };

    const state = {
        barks: []
    }

    const createHtml = (param) => {
        let title = titleMap[param] ? titleMap[param] : titleMap['default'];

        let nextBarkSuggestionsHtml = [];

        if (state.barks.length > config.minBarks) {

            let formattedBarks = formatBarksData(state.barks);

            formattedBarks.forEach((bark) => {
                nextBarkSuggestionsHtml.push(cardTemplate(bark));
        })
        }

        return modalTemplate({
            title: title,
            nextBarkSuggestions: nextBarkSuggestionsHtml.join('')
        });
    }

    const appendToDom = (html) => {
        $('#close-bark-confirm-modal').append(html);
    }

    const showModal = () => {
        $('#close-bark-confirm-modal').modal('show');
    }

    const formatBarksData = (barks) => {
        return barks.slice(0, config.maxBarks);
    }

    const bindListeners = (param) => {
        $('#close-bark-confirm-modal .card-category-link').on('click', (e) => {
            e.preventDefault();

        $('.modal').modal('hide');
        $('#category_id').val($(e.currentTarget).data('category-id'));
        $('#postcode_id').val('-1');
        $('#postcode_type').val('-1');
        $('#category_name_hidden').val('');
        $('#bark_mode').val(param === 'review' ? 'bnb-review-posted' : 'bnb-bark-closed')
        $('#bark_submit').trigger('click');
    });
    }

    const renderModal = (param, barks) => {
        state.barks = barks;
        let html = createHtml(param);
        appendToDom(html);
        bindListeners(param);
        showModal();
    };

    return {
        renderModal
    };
}
